/**
 * Created by admin on 2017/8/28.
 */
import Vue from 'vue'
import { util } from '../service/util'
import moment from 'moment'

let sex = Vue.filter('sex',function (value) {
    if(value == 1){
        return '男'
    }else {
        return '女'
    }
})
let price = Vue.filter('price',function (value) {
    let result = value <= 0 &&  "暂无报价" || value >= 10000 && '联系客服' || value;
    return result;
})
let imgPath = Vue.filter('imgPath',function(value) {
	return util.imgPath(value);
})
let preImgPath = Vue.filter('preImgPath',function(value) {
    return util.preImgPath(value);
})

let adPrice = Vue.filter('adPrice', function(value){
	let res = '';
    if(!value){
        res = '暂无报价';
    } else if(value == 10000){
        res = '联系客服';
    } else {
        res = '广告'+value+'元/30秒';
    }
    return res;
})

let minPrice = Vue.filter('minPrice', function(value){
	let res = '';
    if(!value){
        res = '暂无报价';
    } else if(value == 10000){
        res = '联系客服';
    } else {
        res = '专题'+value+'元/分';
    }
    return res;
})

let toBigCount = Vue.filter('toBigCount', function(value){
    var value = parseInt(value)||0;
    if(value > 1000){
        return (value/10000).toFixed(1)+'万';
    }
    return value;
})

let time = Vue.filter('time',function (value, fmt) {
    return moment(value).format(fmt || 'YYYY.MM.DD');
})
let time2 = Vue.filter('time2',function (value) {
    return moment(value).format('YYYY-MM-DD HH:mm:ss');
})

let way = Vue.filter('way',function (value) {
   if(value == 1){
       return '线下'
   }else if(value ==2){
       return '线上'
   }
})
// 发票类型
let invoiceType = Vue.filter('invoiceType',function (value) {
    if(value == 1){
        return '增值税普通发票'
    }else if(value == 2){
        return '增值税专用发票'
    }
})

let invoiceStatus = Vue.filter('invoiceStatus',function (value) {
    if(value == 1){
        return '未开发票'
    }else if(value == 2){
        return '已开发票'
    }
})
Vue.filter('toString', function(value){
    if(value){
        return JSON.stringify(value);
    }
    return '';
})

Vue.filter('OSS', function (value) {
  return util.getOSS() + value;
})



// WEBPACK FOOTER //
// ./src/filter/filter.js